import { render, staticRenderFns } from "./communityPointsRule.vue?vue&type=template&id=23addbde&scoped=true"
import script from "./communityPointsRule.vue?vue&type=script&lang=js"
export * from "./communityPointsRule.vue?vue&type=script&lang=js"
import style0 from "./communityPointsRule.vue?vue&type=style&index=0&id=23addbde&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23addbde",
  null
  
)

export default component.exports